import { DropdownType, SelectDropDown } from '@ui-kit'
import {
  fetchAllClientPrograms,
  updateAuthUserSelectedTenant,
  updateSelectedClientProgram,
} from '@app-store'
import { useEffect, useState } from 'react'
import { RootState, useAppDispatch, useAppSelector } from '../utils/agent.store'
import { DropDownOption } from '../types/types'
import { ClientDropdownProps } from '../types/common'
import { USER_PROFILES } from '../utils/constants'
import { resetServiceWorkerCacheOnClientSwitch } from '../utils/service-worker.utils'

const ClientProgramDropdown: React.FC<ClientDropdownProps> = ({
  dataQaId = 'clientProgramDropdown',
}) => {
  const dispatch = useAppDispatch()
  const selectedClientProgram = useAppSelector(
    (state: RootState) => state.clientPrograms?.selectedClientPrograms
  )
  const [allTenantProgramOptions, setAllTenantProgramOptions] = useState<
    DropdownType<DropDownOption>[]
  >([])

  const userId = useAppSelector((state: RootState) => state?.authUser?.user?.id)

  const profile = useAppSelector(
    (state: RootState) => state?.authUser?.user?.profile
  )

  const allClientPrograms = useAppSelector(
    (state: RootState) => state?.clientPrograms?.allClientPrograms
  )

  const handleClientProgramChange = async (
    e: DropdownType<DropDownOption, string>
  ) => {
    await resetServiceWorkerCacheOnClientSwitch(
      e.tenant_id?.toString() ?? '-1',
      { prewarm: false }
    )
    dispatch(
      updateAuthUserSelectedTenant(parseInt(e.tenant_id?.toString() ?? '-1'))
    )
    dispatch(
      updateSelectedClientProgram({
        tenant_id: parseInt(e?.tenant_id?.toString() ?? '') ?? -1,
        program_id: parseInt(e?.program_id?.toString() ?? '') ?? -1,
        operational_program_name: e?.label?.split(' - ')?.[1] ?? '',
        name_of_organization: e?.label?.split(' - ')?.[0] ?? '',
        isOverseer: !!e?.isOverseeing,
      })
    )
  }

  const getAllTenantProgramOptions = () => {
    const allTenantOptions = Object.entries(allClientPrograms ?? {}).flatMap(
      ([tenant_id, { name_of_organization, programs }]) =>
        programs.map((program) => ({
          label: `${name_of_organization} - ${program.operational_program_name}`,
          program_id: program.id,
          tenant_id: Number(tenant_id),
          isOverseeing: program.permission_set_name.includes('Overseeing'),
          value: `${tenant_id}-${program.id}`,
        }))
    )
    setAllTenantProgramOptions(allTenantOptions)
  }

  useEffect(() => {
    getAllTenantProgramOptions()
  }, [allClientPrograms])

  useEffect(() => {
    dispatch(
      fetchAllClientPrograms({
        userId:
          profile === USER_PROFILES.STANDARD_USER ||
          profile === USER_PROFILES.SUPPORT
            ? userId?.toString()
            : undefined,
      })
    )
  }, [])

  return allTenantProgramOptions.length ? (
    <div className="flex w-[13rem]" id="client-program-dropdown">
      <SelectDropDown
        label=""
        options={allTenantProgramOptions}
        name="ClientProgram"
        onChange={(e) => handleClientProgramChange(e)}
        className="bg-secondary-50 h-10 w-[8rem] text-xs"
        defaultValue={
          selectedClientProgram?.tenant_id +
          '-' +
          selectedClientProgram?.program_id
        }
        isBordered={false}
        dataQaId={dataQaId}
        isSearchable={true}
        isCrossable={false}
      />
    </div>
  ) : (
    <></>
  )
}
export default ClientProgramDropdown
